import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg width="150" height="150" viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#51545C"
        d="M79.512 86.002h22.286v-3.184H79.512zM57.225 66.9h44.573v-3.185H57.225zM57.225 72.205h44.573v-3.183H57.225z"
      />
      <g transform="translate(36 34)">
        <path
          fill="#50A0D5"
          d="M63.352 16.994c0 .77-.908 1.353-1.187 2.023-.288.693-.072 1.744-.597 2.266-.526.523-1.58.308-2.276.596-.672.277-1.259 1.182-2.032 1.182-.772 0-1.359-.905-2.03-1.182-.697-.288-1.751-.073-2.276-.596-.525-.522-.31-1.573-.598-2.266-.279-.67-1.186-1.254-1.186-2.023 0-.77.907-1.354 1.186-2.023.289-.694.073-1.745.598-2.267.525-.523 1.579-.308 2.275-.596.672-.277 1.26-1.182 2.031-1.182.773 0 1.36.905 2.032 1.182.697.288 1.75.073 2.276.596.525.522.309 1.573.597 2.267.28.669 1.187 1.253 1.187 2.023"
        />
        <path
          fill="#09539F"
          d="M60.855 16.994a3.587 3.587 0 0 1-3.595 3.58 3.588 3.588 0 0 1-3.594-3.58c0-1.978 1.61-3.58 3.594-3.58a3.587 3.587 0 0 1 3.595 3.58"
        />
        <g transform="translate(9.297)">
          <mask id="nc-1" fill="#fff">
            <path d="M.579.252h67.59v89.963H.58z" />
          </mask>
          <path
            fill="#51545C"
            d="M.579.252v39.567h3.718V3.956h60.154v82.555H34.896v3.704H68.17V.252z"
            mask="url(#nc-1)"
          />
        </g>
        <path
          fill="#2364AF"
          d="M33.045 67.633h-4.746V53.182c0-1.605-1.31-2.91-2.921-2.91h-13.14a2.92 2.92 0 0 0-2.92 2.91v14.451H4.571V53.182c0-4.21 3.44-7.637 7.667-7.637h13.139c4.228 0 7.667 3.426 7.667 7.637v14.451z"
        />
        <mask id="nc-2" fill="#fff">
          <path d="M0 94.452h77.466V.252H0z" />
        </mask>
        <path fill="#2364AF" d="M0 94.452h37.746v-33.12H0z" mask="url(#nc-2)" />
        <path
          fill="#78B542"
          d="M27.684 78.157c0 4.847-3.944 8.776-8.81 8.776-4.867 0-8.813-3.929-8.813-8.776 0-4.848 3.946-8.777 8.812-8.777 4.867 0 8.811 3.929 8.811 8.777"
          mask="url(#d)"
        />
        <path fill="#2364AF" d="M17.498 81.016h2.749v-5.719h-2.749z" mask="url(#d)" />
        <path
          fill="#51545C"
          d="M43.671 45.87h22.423v-3.087H43.671zM43.671 59.296h22.423V56.21H43.671zM43.671 72.723h22.423v-3.087H43.671zM43.671 65.989h22.423v-3.087H43.671zM43.671 79.415h22.423V76.33H43.671z"
          mask="url(#d)"
        />
      </g>
    </g>
  </Svg>
)
